import { FilteredInitialItemsI, InitialItemsI, ItemsI } from '../types';

/**
 * MapItems.
 */
export const mapItems = (initialItems: FilteredInitialItemsI): ItemsI =>
  Object.entries(initialItems).reduce(
    (sum, [key, value]) => ({ ...sum, [key]: value.values }),
    {},
  );

const defaultParams = {
  ordered: false,
} as const;

/**
 * MapInitialItems.
 */
export const mapInitialItems = (items: InitialItemsI): FilteredInitialItemsI =>
  Object.entries(items).reduce((sum, [key, value]) => {
    if (Array.isArray(value)) {
      return {
        ...sum,
        [key]: {
          values: value,
          params: defaultParams,
        },
      };
    }
    return { ...sum, [key]: value };
  }, {});
